<template>
    <div class="v-flex lm-border doc-label">
        <d-inc-document-info
            v-model   = "showInfo"
            :document = "document"
        />

        <c-inc-document-icon
            :document = "document"
            :size     = "20"
        />

        <div class="v-flex pa-0" style="margin-top: 4px; color: black; ">
            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                            class="doc-name"
                        >
                            {{ document.name }}
                        </div>
                    </template>

                    <div>
                        {{ document.name }}
                    </div>
                </v-tooltip>



            </div>

            <div class="doc-type">
                {{ document.typename }}
            </div>
            <div style="margin-top: -6px">
                <c-toolbar-button
                    color   = "primary"
                    icon    = "mdi-information-outline"
                    tooltip = "DMS Infos zum Dokument"
                    @click  = "onInfo"
                />
            </div>
        </div>
    </div>
</template>

<script>

import CIncDocumentIcon from "@/modules/dms/common/components/CIncDocumentIcon.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import DIncDocumentInfo from "@/modules/dms/info/components/DIncDocumentInfo.vue";

export default {
    name: "PDmsDetailMenuEntryLabel",

    components: {
        DIncDocumentInfo,
        CToolbarButton,
        CIncDocumentIcon
    },

    props: {
        document: {

        }
    },

    data: () => ({
        showInfo: false,
    }),

    methods: {
        onInfo () {
            this.showInfo = true;
        }
    }
}
</script>

<style scoped>

.doc-label {
    height: 32px;
    padding: 2px 4px 0;
}

.doc-name {
    max-width: 400px;
    min-width: 400px;
}

.doc-type {
    max-width: 150px;
    min-width: 150px;

}

.doc-name, .doc-type {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 5px;
    font-size: 14px;
}


</style>